import type { ReactElement } from 'react';
import type { TabListProps as AriaTabListProps } from 'react-aria-components';
import { TabList as AriaTabList } from 'react-aria-components';
import cx from 'clsx';
import type { TabProps } from '../tab/tab';
import { Tab } from '../tab/tab';
import styles from './tab-list.module.css';

export interface TabListProps extends AriaTabListProps<object> {
  tabs: TabProps[];
  additionalContent?: React.ReactNode;
  noBorder?: boolean;
}

export function TabList({
  tabs,
  className,
  noBorder,
  additionalContent,
  ...props
}: TabListProps): ReactElement {
  return (
    <div className={cx(styles.container, noBorder ? styles.noBorder : className)}>
      <AriaTabList className={styles.tabList} {...props}>
        {tabs.map(
          (
            {
              id,
              title,
              icon,
              hasNotifications,
              hasDivider,
              count,
              maxCount,
              isDisabled,
              otherDataTest,
            },
            index
          ) => (
            <Tab
              count={count}
              data-test-tabs-nav-item={index}
              data-test-tabs-nav-item-value={id}
              hasDivider={hasDivider}
              hasNotifications={hasNotifications}
              icon={icon}
              id={id}
              isDisabled={isDisabled}
              key={id}
              maxCount={maxCount}
              title={title}
              {...otherDataTest}
            />
          )
        )}
      </AriaTabList>
      {additionalContent}
    </div>
  );
}
